import './NotifPane.css';
import NotificationCard from './NotificationCard/NotificationCard';

import {useContext, useState, useRef} from 'react';
import NotificationsContext from '../../components/contexts/NotificationsContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
   faUserPlus,
   faUserXmark,
   faUsers,
} from '@fortawesome/free-solid-svg-icons'
import { useEffect } from 'react';

const API_endpoint = "https://webdev.cse.buffalo.edu/hci/api/api/deekstra";
const notifRequestPath = "/users/";
const attrPending = "&attributes=%7B%0A%20%20%22path%22%3A%20%22status%22%2C%0A%20%20%22equals%22%3A%20%22pending%22%0A%7D";
const attrAccepted = "&attributes=%7B%0A%20%20%22path%22%3A%20%22status%22%2C%0A%20%20%22equals%22%3A%20%22accepted%22%0A%7D";

/*  Function:   getNotifs [DEPRACATED] - Replaced with connection API
    Purpose:    Get the list of notifications for the current user
                This can be used to send notifications to a user
    Returns:    Array containing this user's notifications attribute
*/
async function getNotifs() {
    const notifResponse = await fetch(`${API_endpoint}${notifRequestPath}${sessionStorage.getItem("user")}`, {
        method: "GET",
        headers: { }
    });
    const notifObj = await notifResponse.json();
    console.log(notifObj);
    getNotifCount();
    return notifObj;
} 

/*  Function:   getPendingRequests
    Purpose:    Get the list of pending friend requests for the current user.
                This can be used to notify the user when another person has sent them a friend request
    Returns:    Array containing the pending friend requests
*/
async function getPendingRequests() {
    const pendingResponse = await fetch(`${API_endpoint}/connections?toUserID=${sessionStorage.getItem("user")}${attrPending}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("token")
        }
    });
    // console.log(pendingResponse);
    const pendingObj = await pendingResponse.json();
    // console.log(`User ID: ${sessionStorage.getItem("user")}`);
    // console.log(pendingObj[0]);
    if (pendingObj[0])
        return pendingObj[0];
    else
        return null;
}
/*  Function:   getAcceptedRequests
    Purpose:    Get the list of accepted friend requests for the current user.
                This can be used to notify the user when somebody has accepted their friend request
    Returns:    Array containing the accepted friend requests
*/
async function getAcceptedRequests() {
    const pendingResponse = await fetch(`${API_endpoint}/connections?toUserID=${sessionStorage.getItem("user")}${attrAccepted}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("token")
        }
    });
    console.log(pendingResponse);
    const pendingObj = await pendingResponse.json();
    console.log(`User ID: ${sessionStorage.getItem("user")}`);
    console.log(pendingObj[0]);
    if (pendingObj[0])
        return pendingObj[0];
    else
        return null;
}

/*  Function:   acceptRequest
    Purpose:    Change the status of a connection to "accepted"
                Attached to a button on the notification card of a friend request
    Returns:    none
*/
async function acceptRequest(req) {
    // console.log(req.attributes.status);
    console.log("Before Patch:",req.id, req.attributes.status);
    const connectionObj = await fetch(`${API_endpoint}/connections/${req.id}`, {
        method: "PATCH",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("token")
        },
        body: JSON.stringify({
            attributes: {
                status: "accepted",
            }
        })
    });
    const Connection = await connectionObj.json();
    // console.log("After Patch:", Connection.id, Connection.attributes.status);
}

/*  Function:   rejectedRequest
    Purpose:    Delete the connection between the two users
                Attached to a button on the notification card of a friend request
    Returns:    none
*/
async function rejectRequest(req) {
    console.log("Deleting:", req.id);
    const connectionObj = await fetch(`${API_endpoint}/connections/${req.id}`, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("token")
        },
    });
    // const Connection = await connectionObj.json();
    // console.log("Deleted: ", Connection, Connection);
}


/*  Function:   restoreToPending
    Purpose:    Change the status of a connection to "pending". For debug use only.
    Parameters: reqID - the ID of the connection to be modified
    Returns:    none
*/
async function restoreToPending(reqID) {
        // console.log(req.attributes.status);
        const connectionObj = await fetch(`${API_endpoint}/connections/${reqID}`, {
            method: "PATCH",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            },
            body: JSON.stringify({
                attributes: {
                    status: "pending",
                }
            })
        });
        const Connection = await connectionObj.json();
        // console.log("After Patch:", Connection.id, Connection.attributes.status);
}




/*  Function:   getNotifCount - [DEPRECATED] Not needed with swap to Connections API
    Purpose:    Get the amount of notifications for the current user
    Returns:    The amount of notifCount attribute of the current user
*/
async function getNotifCount() {
    // Retrieve the user's information
    const notifResponse = await fetch(`${API_endpoint}${notifRequestPath}${sessionStorage.getItem("user")}`, {
        method: "GET",
        headers: { }
    });
    const notifObj = await notifResponse.json();
    if (!notifObj.attributes.notifCount)    // If there is no notifCount, return 0
        return 0;
    else {  // Otherwise return it
        // console.log(notifObj.attributes.notifCount);
        // console.log(notifObj.attributes.notifications);
        return notifObj.attributes.notifCount;
    }
}

/*  Function:   createNotif [DEPRECATED] - No longer needed with swap to Connections API
    Purpose:    Create a mock notification. For debug use only.
    Returns:    none
*/
async function createNotif() {
    // async function createNotif() {
    let msg;
    let notifType = "FriendRequest";
    let sendingUser = "Geralt";
    if (notifType === "FriendRequest") {
        msg = `${sendingUser} sent you a friend request!`;
    }
    else if(notifType === "Message") {
        msg = `${sendingUser} sent you a message!`
    }
    else return;
    console.log(msg);

    // Increment the notification count
    let notifNumber = await getNotifCount();
    notifNumber++;
    console.log(`New notif number: ${notifNumber}`);

    // Build the new notification
    const newNotif = {
        notifType:notifType,
        sendingUser:sendingUser,
        msg: msg,
    }
    
    // Get the notifications array, if it exists
    const notifArrResponse = await fetch(`${API_endpoint}${notifRequestPath}${sessionStorage.getItem("user")}`, {
        method: "GET",
        headers: { }
    });

    const notifArrObj = await notifArrResponse.json();  // Turn the response into a JSON object, which contains the array
    let notifArr = notifArrObj.attributes.notifications;    // weird situation where we want to declare an array using let.. we may change where the pointer goes
    if (notifArr)   // If the notifications array already exists for this user, append the new notification to the end
        notifArr.push(newNotif);
    else            // If this user doesn't have a notifications array, create it with the new notification as its' only element
        notifArr = [newNotif];

    // Update the user's notification info
    const notifResponse = await fetch(`${API_endpoint}${notifRequestPath}${sessionStorage.getItem("user")}`, {
        method: "PATCH",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
        },
        body: JSON.stringify({
            attributes: {
                notifCount: notifNumber,
                notifications: notifArr
            }
        })
    });
    
    const notifObj = await notifResponse.json();
    // console.log(notifObj);
}


/*  Function:   notifPane
    Purpose:    React component to display the users notifications
    Returns:    React component
*/
function NotifPane() {
    const [activeTab, setActiveTab] = useState('newRequest')

    const [ntfs, SetNtfs]=useState([])
    const [displayNtfs, SetDisplayNtfs] = useState([])
    const [accNtfs, SetAccNtfs] = useState([]);
    const [displayAccNtfs, SetDisplayAccNtfs]=useState([]);

    useEffect(() => {
        async function fetchNotifs() {
            if (activeTab != "newRequest") return;
                const notifObj = await getPendingRequests();
                SetNtfs(notifObj);
        
            
            // console.log(notifObj);
            if (notifObj) {
                // console.log("Creating notificationList");
                // for (let n in notifObj) console.log(notifObj[n].fromUser.attributes.name);
                const newNotificationList = await Promise.all(notifObj.map(n => {
                    return (
                        <div key = {n.id}>
                            <NotificationCard {...n} />
                        </div>
                    )
                }));

                // for (let n in newNotificationList) {console.log(newNotificationList[n])}
                SetDisplayNtfs(newNotificationList);
            } else {
                console.log("No pending requests");
            }
        }
        fetchNotifs();
    })


    useEffect(()=>{
        const interval = setInterval(async() =>  {
            // console.log("Active tab:", activeTab);
            if (activeTab != "newRequest") return;
            const notifObj = await getPendingRequests();
            SetNtfs(notifObj);
    
        
            // console.log(notifObj);
            if (notifObj) {
                // console.log("Creating notificationList");
                // for (let n in notifObj) console.log(notifObj[n].fromUser.attributes.name);
                const newNotificationList = await Promise.all(notifObj.map(n => {
                    return (
                        <div key = {n.id}>
                            <NotificationCard {...n} />
                        </div>
                    )
                }));

                // for (let n in newNotificationList) {console.log(newNotificationList[n])}
                SetDisplayNtfs(newNotificationList);
            } else {
                console.log("No pending requests");
            }
        // showNotifications();
    },1000);
    return () => clearInterval(interval);
});

    // async function refreshNotifications() {
    //     const notifObj = await getPendingRequests();
    //     SetNtfs(notifObj);
    //     if (notifObj) {
    //         const newNotificationList = await Promise.all(notifObj.map(n => {
    //             return (<div className="notif-card" key="{n}">
    //                 <div className="notif-msg"><div className="notif-sender">{n.fromUser.attributes.name.toString()}</div> has sent you a friend request!</div>
    //                 <div className="notif-accept-button">
    //                     <button type="button" className="nav-tab" onClick={async () => {
    //                         await acceptRequest(n);
    //                         // await refreshNotifications();

    //                     }}>Accept</button>
    //                 </div>
    //                 <div className="notif-reject-button">
    //                     <button type="button" className="nav-tab" onClick={() => rejectRequest(n)}>Reject</button>
    //                 </div>
    //             </div>)}));
    //         // for (let n in newNotificationList) {console.log(newNotificationList[n])}
    //         SetDisplayNtfs(newNotificationList);
    //     } else {
    //         console.log("No pending requests");
    //     }
    // }

    // restoreToPending(21);

    // async function showAcceptedRequests() {
    //     if (activeTab != "acceptedRequests") return;
    //     const notifObj = await getAcceptedRequests();
    //     SetAccNtfs(notifObj);
    //     if (notifObj) {
    //         console.log("Creating accepted notification list");
    //         const newNotificationList = await Promise.all(notifObj.map(n => {
    //             return (<div className="notif-card" key="{n}">
    //                 <div className = "notif-msg"><div className="notif-sender">{n.fromUser.attributes.name.toString()}</div> has accepted your friend request!</div>
    //                 <div className="notif-reject-button">
    //                     {/* <button type="button" className="nav-tab" onClick={() => console.log(n)}>Dismiss</button> */}
    //                 </div>
    //             </div>)}));
    //         SetDisplayAccNtfs(newNotificationList);
    //     } 
    //     else { console.log("No accepted requests"); }
        
    // }
    // setInterval(showNotifications, 10000)

    useEffect(() => {
        document.title = "Notifications";  
    }, []);

    return(
        // <div className = "notif-container">
            <div className = "notif-bg">
                {/* <h1> Notifications </h1> */}
                <div className="Pane-Header">
                    <h1 > Notifications </h1>
                </div>
                <div className="notif-wrapper">
                    <div className = "notif-arr">
                        {displayNtfs}
                    </div>
                </div>
                {/* </div> */}
            </div>
        // </div>
    )
}
export default NotifPane